export const PLAYER_ROLES = {
  CAPTAIN: 'Owner/Captain',
  VICE_CAPTAIN: 'Second Captain',
  PLAYER: 'Player',
};
